module.exports = __webpack_public_path__ + "static/media/super_pack_en_chien_automne.64513c7c.png";